module.exports = __webpack_public_path__ + "static/img/title-en.dcf3466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/title/title-en.png
// module id = FGx8
// module chunks = 1